import { get } from './request';

export const WebSocketApi = {
    getWebsocketEndpoint: (): Promise<string> =>
        get(process.env.REACT_APP_COCALERO_API_URL + '/websocket_endpoint', true).then(
            (res: { endpoint: string }) => res.endpoint
        ),
};
